// web/src/lib/scryClient.ts — Firestore facade (no /api calls)

import {
  getCardById as fsGetCardById,
  printsById as fsPrintsById,
  rulingsById as fsRulingsById,
  search as fsSearch,
  searchPrints as fsSearchPrints,
  getCardByNamedExact as fsNamedExact,
  resolveBundle as fsResolveBundle,
  printsByOracle as fsPrintsByOracle,
} from "./scryApiClient";

// Keep standalone exports (some code may import these directly)
export const getCardById = fsGetCardById;
export const printsById = fsPrintsById;
export const rulingsById = fsRulingsById;
export const search = fsSearch;
export const searchPrints = fsSearchPrints;
export const getCardByNamedExact = fsNamedExact;
export const resolveBundle = fsResolveBundle;

// Back-compat object API used by V2Modal/QuickSearchOverlay
export const scry = {
  // Keep signature; ignore params since Firestore adapter handles defaults
  search: (term: string, _params?: any, signal?: AbortSignal) => fsSearch(term, signal),
  resolveBundle: fsResolveBundle,
  getById: (id: string, signal?: AbortSignal) => fsGetCardById(id, signal),
  printsById: (id: string, signal?: AbortSignal) => fsPrintsById(id, signal),
  printsByOracle: (oid: string, signal?: AbortSignal) => fsPrintsByOracle(oid, signal),
  rulingsById: (id: string, signal?: AbortSignal) => fsRulingsById(id, signal),
  // Optional autocomplete: keep as no-op unless you add a Firestore impl here
  autocomplete: async (_q: string, _signal?: AbortSignal) => ({ data: [] as string[] }),
  // Named exact (returns { data } like your callers expect)
  namedExact: async (name: string, signal?: AbortSignal) => {
    const card = await fsNamedExact(name);
    return { data: card ? [card] : [] };
  },
};

// Image helper unchanged
export function scryImageUrl(id: string, size: "small" | "normal" | "large" = "normal") {
  const px = size === "small" ? "small" : size === "large" ? "large" : "normal";
  return `https://cards.scryfall.io/${px}/front/${id.slice(0, 1)}/${id.slice(1, 2)}/${id}.jpg`;
}
